import { login } from '@/components'
import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
  type RouteRecordRaw
} from 'vue-router'
import NProgress from 'nprogress'
import { nextTick } from 'vue'
import { http } from '@/utils'
import { saveToken } from '@/utils/token'
import { ytWebTracking } from '@/utils/web-Tracking'
import radioPageBackgroundImg from '@/assets/images/mp3/playerbj.png'
import vipPageBackgroundImg from '@/assets/images/icon/vip2/bj@2x.png'

NProgress.configure({
  showSpinner: false // 是否显示加载ico;是否在显示加载图标
})

/** 电台播放器内仅切换题目 id：不表现为整页刷新 */
const isRadioPlayerInternalNav = (to: RouteLocationNormalized, from: RouteLocationNormalized) =>
  to.name === 'RadioPlayer' && from.name === 'RadioPlayer'

interface MetaType {
  hide?: boolean
  backgroundColor?: string
  // 是否为自定义菜单下拉
  custom?: true
  cacheList?: string[]
  name?: string //名称菜单名称
  /** 埋点上报的页面名称（优先于路由 name，名称见《PTE埋点》文档） */
  trackingName?: string
  keepAlive?: boolean
  noAuth?: boolean //是否需要路由验证
  target?: '_blank'
  title?: string
  isLink?: boolean
  notMENU?: boolean //不显示子菜单
  breadcrumbTitle?: string
}
export interface MyRoute1 extends Omit<RouteRecordRaw, 'meta'> {
  meta?: MetaType // 根据需求设置额外的meta字段
}
export interface MyRoute extends Omit<MyRoute1, 'children'> {
  children?: MyRoute1[] // 根据需求设置额外的children字段
}

/** MP3 电台 body 背景：使用播放器背景图铺满整页 */
const radioPageBackground = `url(${radioPageBackgroundImg}) no-repeat center center / cover fixed`
const vipPageBackground = `url(${vipPageBackgroundImg}) no-repeat center center / 100% 100% fixed`

const menus: MyRoute[] = [
  {
    path: '/',
    name: '首页',
    meta: {
      trackingName: '首页',
      name: '首页',
      title: '羊驼PTE官网 - PTE学习_PTE考试培训_PTE真题_PTE机经'
    },
    component: () => import('@/views/home/index.vue')
  },
  {
    path: 'high',
    name: 'high',
    meta: {
      trackingName: '高频库',
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
      name: '高频库',
      custom: true,
      keepAlive: true,
      title: '高频库'
    },
    component: () => import('@/views/high/index.vue')
  },
  // 全题库
  {
    path: 'question',
    name: '全题库',
    meta: {
      trackingName: '全题型练习',
      name: '全题库',
      custom: true,
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
      title: '全题库'
    },
    component: () => import('@/views/q-type-list/index.vue')
  },
  {
    path: 'tools',
    name: '学习工具',
    meta: {
      name: '学习工具',
      custom: true,
      title: '学习工具'
    },
    children: [
      {
        path: 'favorites',
        name: '收藏夹',
        meta: {
          trackingName: '(旧)收藏夹',
          // 旧收藏夹已下线，保留路由兼容历史链接，但从「学习工具」菜单隐藏（新入口 /tools/collect）
          hide: true,
          name: '(旧)收藏夹',
          title: '收藏夹',
          backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
        },
        component: () => import('@/views/favorites/index.vue')
      },
      {
        path: 'collect',
        name: 'Collect',
        meta: {
          trackingName: '收藏夹',
          name: '收藏夹',
          title: '收藏夹',
          backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
        },
        component: () => import('@/views/collect/index.vue')
      },
      {
        path: '/mock',
        name: 'PTE模考',
        redirect: '/mock/exam',
        meta: {
          name: 'PTE模考',
          backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
        }
      },
      {
        path: 'favorites/details',
        name: '收藏夹详情',
        meta: {
          trackingName: '收藏夹详情页',
          name: '收藏夹详情',
          hide: true,
          backgroundColor: '#FAFAFA',
          title: '收藏夹详情'
        },
        component: () => import('@/views/favorites/details.vue')
      },

      {
        path: '/IntensiveListening',
        name: 'IntensiveListening',
        meta: { name: '精听素材', title: '精听素材' }
      },
      {
        path: '/AnalysisTranscript',
        name: 'AnalysisTranscript',
        meta: { name: '成绩单分析', title: '成绩单分析' }
      },
      {
        path: '/radio',
        name: 'Radio',
        meta: {
          trackingName: 'MP3电台',
          name: 'MP3电台',
          title: 'MP3真题电台'
        }
      },
      {
        path: '/word-recite',
        name: 'WordRecite',
        meta: {
          trackingName: '斩单词主页',
          name: '斩单词',
          title: '斩单词',
          noAuth: true
        },
        component: () => import('@/views/word-recite/index.vue')
      },
      {
        path: '/word-recite/start',
        name: 'WordReciteStart',
        meta: {
          trackingName: '开始斩单词页',
          name: '开始斩单词',
          title: '开始斩单词',
          hide: true,
          noAuth: true
        },
        component: () => import('@/views/word-recite/start.vue')
      },
      {
        path: '/word-recite/word-type-list',
        name: 'WordReciteWordTypeList',
        meta: {
          trackingName: '单词列表页',
          name: '单词列表',
          title: '单词列表',
          hide: true
        },
        component: () => import('@/views/word-recite/word-type-list.vue')
      }
    ]
  },
  // keepAlive: true,
  {
    path: '/learning',
    name: 'learning',
    meta: {
      trackingName: '学习中心',
      name: '学习中心',
      title: '学习中心',
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
    },
    component: () => import('@/views/learning/index.vue')
  },
  // 图标库管理页（开发工具，不进导航菜单，免登录）
  {
    path: '/icons',
    name: 'IconGallery',
    meta: {
      name: '图标库',
      title: '图标库',
      hide: true,
      noAuth: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/icon-gallery/index.vue')
  },
  {
    path: '/vip',
    meta: { name: 'VIP', target: '_blank', title: 'PTE VIP开通', hide: true },
    name: 'vip'
  },
  {
    path: '/material',
    meta: { name: '课程资料', title: '课程资料' },
    name: 'material'
  },
  // 高频题目列表

  // 任意题型列表
  {
    path: 'question-list/:type/:id',
    name: 'QuestionList',
    meta: {
      trackingName: '题型列表页',
      title: '全题库',
      name: '全题库',
      hide: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/question-list/index.vue')
  },
  // 练习页
  {
    path: '/:slug(exp.*?)/:typeCode/:wpId/:questionsId?', //  /阅读|口语.../题型/id/questionsId
    name: 'Exercises',
    meta: {
      trackingName: '练习页',
      name: '全题库',
      title: '全题库',
      hide: true,
      backgroundColor: '#FAFAFA'
    },
    component: () => import('@/views/exercises/index.vue')
  },
  // 高频微课(列表页)
  {
    path: '/micro-course',
    name: 'MicroCourse',
    meta: {
      trackingName: 'PTE微课',
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true,
      name: 'PTE微课',
      title: 'PTE微课'
    },
    component: () => import('@/views/micro-course/index.vue')
  },
  // 高频微课详情
  {
    path: '/micro-info/:type/:id',
    name: 'MicroInfo',
    meta: {
      trackingName: '高频微课详情页',
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true,
      title: '高频微课详情'
    },
    component: () => import('@/views/micro-info/index.vue')
  },

  {
    path: '/video-info/:courseType/:id',
    name: 'VideoInfo',
    meta: {
      trackingName: '高频微课视频详情页',
      hide: true,
      backgroundColor: '#FAFAFA',
      keepAlive: true,
      title: '高频微课视频详情'
    },
    props: (route) => ({
      microCourseId: route.query.microCourseId
    }),
    component: () => import('@/views/video-info/index.vue')
  },
  {
    path: '/center',
    name: 'center',
    meta: {
      trackingName: '个人中心',
      name: '个人中心',
      backgroundColor: '#FAFAFA',
      hide: true,
      title: '个人中心'
    },
    component: () => import('@/views/myCenter/index.vue')
  },
  {
    path: '/mock', //测试页
    name: 'mock',
    redirect: '/mock/exam',
    meta: {
      hide: true,
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
      title: 'PTE模考',
      name: 'PTE模考'
    },
    component: () => import('@/views/mock/index.vue'),
    children: [
      {
        path: 'record',
        name: 'record',
        meta: {
          trackingName: '模考记录页',
          hide: true,
          backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
          title: '模考记录'
        },
        component: () => import('@/views/mock/subpage/record/index.vue')
      },
      {
        path: 'exam',
        name: 'exam',
        meta: {
          trackingName: 'PTE模考页',
          hide: true,
          backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
          title: 'PTE仿真模拟考试'
        },
        component: () => import('@/views/mock/subpage/exam/index.vue')
      },

      {
        path: 'report/:id',
        name: 'MockReport',
        meta: {
          trackingName: '模考报告页',
          hide: true,
          backgroundColor: '#FAFAFA',
          title: '模考报告',
          noAuth: true
        },
        component: () => import('@/views/mock/MockReport/index.vue')
      }
    ]
  },
  {
    path: '/IntensiveListening',
    name: 'IntensiveListening',
    redirect: '/IntensiveListening/ListeningList',
    meta: {
      hide: true,
      title: '精听素材',
      name: '精听素材',
      backgroundColor: `linear-gradient(
        138deg,
        #EDEFFD 0%,
        #EFEFFD 100%
      )`
    },
    component: () => import('@/views/IntensiveListening/index.vue'),
    children: [
      {
        path: '/IntensiveListening/ListeningList',
        name: 'ListeningList',
        component: () =>
          import('@/views/IntensiveListening/module/ListeningList/ListeningList.vue'),
        children: [
          {
            path: '/IntensiveListening/ListeningList/list',
            name: 'ListeningListList-List',
            meta: { trackingName: '精听素材列表页' },
            component: () => import('@/views/IntensiveListening/module/ListeningList/list.vue')
          },
          {
            path: '/IntensiveListening/ListeningList/details',
            name: 'ListeningListList-details',
            meta: { trackingName: '精听素材详情页' },
            component: () => import('@/views/IntensiveListening/module/ListeningList/info.vue')
          }
        ]
      },
      {
        path: '/IntensiveListening/ListeningListDetails',
        name: 'ListeningListDetails',
        meta: {
          trackingName: '精听跟读页',
          name: '',
          backgroundColor: radioPageBackground
        },
        component: () => import('@/views/IntensiveListening/module/ListeningListDetails.vue')
      }
    ]
  },
  {
    path: '/material',
    name: 'material',
    meta: {
      hide: true,
      name: 'material',
      noAuth: true,
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
      title: '课程资料'
    },
    component: () => import('@/views/information/layout.vue'),
    redirect: '/material/index',
    children: [
      {
        path: '/material/index',
        name: 'materialIndex',
        meta: { trackingName: '课程资料' },
        component: () => import('@/views/information/index.vue')
      },
      {
        path: '/material/purchase/:id',
        name: 'purchase',
        meta: {
          trackingName: '付费课程详情页',
          name: 'purchase',
          noAuth: true,
          backgroundColor: '#FAFAFA',
          title: '课程详情'
        },
        component: () => import('@/views/paid-course-info/index.vue')
      },
      {
        path: '/material/SpecialTopic/:id',
        name: 'SpecialTopic',
        meta: {
          trackingName: '专题详情页',
          name: 'SpecialTopic',
          noAuth: true,
          backgroundColor: '#FAFAFA',
          title: '专题详情'
        },
        component: () => import('@/views/material/SpecialTopic.vue')
      },
      {
        path: '/material/CourseDetails/:id',
        name: 'CourseDetails',
        meta: {
          trackingName: '课程详情页',
          name: 'CourseDetails',
          noAuth: false,
          backgroundColor: '#FAFAFA',
          title: '课程详情'
        },
        component: () => import('@/views/material/CourseDetails.vue')
      }
    ]
  },
  {
    path: '/basic-test',
    name: 'BasicTest',
    redirect: '/basic-test/index',
    meta: {
      name: '基础能力测试',
      hide: true,
      noAuth: false
    },
    children: [
      {
        path: '/basic-test/index/:step?',
        name: 'BasicTestIndex',
        meta: { trackingName: '基础能力测试页' },
        component: () => import('@/views/basic-test/index.vue')
      },
      {
        path: '/basic-test/result',
        name: 'BasicTestResult',
        meta: { trackingName: '基础能力测试结果页' },
        component: () => import('@/views/basic-test/result.vue')
      }
    ]
  },
  {
    path: '/radio',
    name: 'Radio',
    meta: {
      hide: true,
      name: 'MP3电台',
      title: 'MP3真题电台'
    },
    component: () => import('@/views/radio/index.vue')
  },
  {
    path: '/radio/detail/:id',
    name: 'RadioDetail',
    meta: {
      trackingName: 'MP3电台题型列表页',
      hide: true,
      name: 'MP3电台',
      title: 'MP3真题电台-题型列表',
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
    },
    component: () => import('@/views/radio/detail.vue')
  },
  {
    path: '/radio/player/:id',
    name: 'RadioPlayer',
    meta: {
      trackingName: 'MP3电台播放页',
      hide: true,
      name: 'MP3电台',
      title: 'MP3真题电台-音频播放',
      backgroundColor: radioPageBackground
    },
    component: () => import('@/views/radio/player.vue')
  },
  {
    path: 'AnalysisTranscript',
    name: 'AnalysisTranscript',
    meta: {
      backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`,
      hide: true,
      name: '成绩单分析',
      title: '成绩单分析'
    },
    component: () => import('@/views/AnalysisTranscript/layout.vue'),
    redirect: '/AnalysisTranscript/index',
    children: [
      {
        path: '/AnalysisTranscript/index',
        name: 'AnalysisTranscriptIndex',
        meta: { trackingName: '成绩单分析页' },
        component: () => import('@/views/AnalysisTranscript/index.vue')
      },
      {
        path: '/AnalysisTranscript/result/:id',
        name: 'AnalysisTranscriptResult',
        meta: { trackingName: '成绩单分析结果页' },
        component: () => import('@/views/AnalysisTranscript/result.vue')
      },
      {
        path: '/AnalysisTranscript/record',
        name: 'AnalysisTranscriptRecord',
        meta: { trackingName: '成绩单分析记录页' },
        component: () => import('@/views/AnalysisTranscript/record.vue')
      }
    ]
  }
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果存在已保存的位置（通常是通过浏览器的前进/后退按钮触发导航），则返回该位置
      return savedPosition
    }
    // 播放器内只改路由 id 时保持当前滚动位置，避免像整页刷新一样跳回顶部
    if (isRadioPlayerInternalNav(to, from)) {
      return false
    }
    return { top: 0, left: 0 }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/topLayout/index.vue'),
      children: [
        {
          path: '/',
          name: 'Layout',
          component: () => import('@/components/layout/index.vue'),
          meta: {
            name: '首页',
            title: '羊驼PTE官网 - PTE学习_PTE考试培训_PTE真题_PTE机经',
            breadcrumbTitle: '首页',
            backgroundColor: `linear-gradient(270deg, #EDEFFD 0%, #F0EFFD 100%)`
          },
          children: [...(menus as unknown as RouteRecordRaw[])]
        },
        {
          path: '/vip',
          name: 'vip',
          meta: {
            trackingName: 'VIP开通页',
            name: 'vip',
            noAuth: true,
            title: 'PTE VIP开通',
            backgroundColor: vipPageBackground
          },
          component: () => import('@/views/vip/index.vue')
        }
      ]
    },
    {
      path: '/home',
      name: 'HomeRedirect',
      redirect: '/',
      meta: {
        hide: true
      }
    },
    {
      path: '/daily-forecast-summary/:dateToken',
      name: 'WeeklyForecastSummary',
      meta: {
        trackingName: '每日预测分享页',
        hide: true,
        noAuth: true,
        backgroundColor: '#F5F7FB',
        title: '羊驼每日预测'
      },
      component: () => import('@/views/weekly-forecast-summary/index.vue')
    },
    {
      path: '/week-frequency-change-summary',
      alias: '/week-frequency-change-summary/core',
      name: 'WeekFrequencyChangeSummary',
      meta: {
        trackingName: '高频预测榜分享页',
        hide: true,
        noAuth: true,
        backgroundColor: '#F5F7FB',
        title: '羊驼高频预测榜'
      },
      component: () => import('@/views/week-frequency-change-summary/index.vue')
    },
    // 课程详情页
    {
      path: '/course-info',
      name: 'CourseInfo',
      meta: {
        trackingName: '课程介绍页',
        hide: true,
        backgroundColor: '#FAFAFA',
        noAuth: true
      },
      component: () => import('@/views/course-info/index.vue')
    },
    {
      path: '/RecordTest',
      name: 'RecordTest',
      meta: {
        noAuth: true
      },
      component: () => import('@/views/test/RecordTest.vue')
    },
    {
      path: '/PTE-MockExam',
      name: 'PTE-MockExam',
      meta: {
        trackingName: '完整模考页',
        backgroundColor: `#F7F7F7`,
        title: '羊驼PTE-完整模考-'
      },
      component: () => import('@/views/mock/MockExam/index.vue')
    },
    {
      path: '/H5',
      name: 'H5Page',
      children: [
        {
          path: 'report/:id',
          name: 'h5Report',
          meta: {
            trackingName: 'H5模考成绩单页',
            title: '模考测评成绩单',
            noAuth: true
          },
          component: () => import('@/views/mock/MockReport/index.vue')
        }
      ]
    },
    {
      path: '/wow-vip',
      name: 'WowVip',
      meta: {
        trackingName: 'WowVIP开通页',
        hide: true,
        noAuth: true
      },
      component: () => import('@/views/vip/index.vue')
    },
    {
      path: '/pte-plug',
      name: 'PtePlug',
      meta: {
        trackingName: '插件下载页',
        hide: true,
        noAuth: true
      },
      component: () => import('@/views/pte-plug/index.vue')
    },
    {
      path: '/pte-plug/install',
      name: 'PlugInstall',
      meta: {
        trackingName: '插件安装页',
        hide: true,
        noAuth: true
      },
      component: () => import('@/views/pte-plug/install.vue')
    },
    {
      path: '/word-study',
      name: 'WordStudy',
      meta: {
        trackingName: '单词练习页',
        name: '单词练习',
        title: '单词练习',
        hide: true
      },
      component: () => import('@/views/word-study/index.vue')
    },
    {
      path: '/stream-training',
      name: 'StreamTraining',
      meta: {
        trackingName: '题型流式特训页',
        name: '题型流式特训',
        title: '题型流式特训',
        hide: true
      },
      component: () => import('@/views/404.vue')
    },
    {
      path: '/word-recite/practice-result',
      name: 'WordRecitePracticeResult',
      meta: {
        trackingName: '单词练习结果页',
        name: '练习结果',
        title: '练习结果',
        hide: true
      },
      component: () => import('@/views/word-recite/practice-result/index.vue')
    },
    {
      path: '/:pathMatch(.*)',
      name: '404',
      meta: {
        hide: true,
        noAuth: true
      },
      component: () => import('@/views/404.vue')
    }
  ]
})
router.beforeEach(async (to, from) => {
  // 模考报告默认携带 ?v=1
  if (to.name === 'MockReport' && to.query.v === undefined) {
    return { ...to, query: { ...to.query, v: '1' } }
  }
  if (!isRadioPlayerInternalNav(to, from)) {
    NProgress.start() // 进度条开始
  }
  ytWebTracking.pageEnter(to, from)
  if (to.query.mobileToken) {
    try {
      const data = await http.post(
        '/api/auth/getTokenByMobileToken',
        {},
        {
          headers: {
            mobileToken: to.query.mobileToken as string,
            token: ''
          }
        }
      )
      if (data.data.token) {
        saveToken(data.data.token)
        window.location.href = router.resolve({
          ...to,
          query: (() => {
            const query = to.query
            delete query.mobileToken
            return query
          })()
        }).href
      }
    } catch {
      nextTick(() => {
        setTimeout(() => {
          login()
        }, 500)
      })
    }
  }
  // 侧边栏手机号码登录
  if (to.query.phone && to.name === '首页') {
    try {
      const data = await http.get(
        '/api/auth/getFreeTokenByPhone',
        { phone: to.query.phone as string },
        {
          headers: {
            token: ''
          }
        }
      )
      if (data.data.token) {
        saveToken(data.data.token)
        router.replace({ path: '/', query: {} }).then(() => {
          window.location.reload()
        })
      }
    } catch {
      nextTick(() => {
        setTimeout(() => {
          login()
        }, 500)
      })
    }
  }
  if (to.query.token && to.name === '首页') {
    saveToken((to.query.token as string) || '')
    window.location.href = router.resolve('/').href
  }

  // 判断是否不需要鉴权
  if (to.name === '首页' || localStorage.getItem('token') || to.meta.noAuth) {
    const toMeta = to.meta as MetaType
    if (toMeta.backgroundColor) {
      document.body.style.background = toMeta.backgroundColor
    }
    if (to.path.replace(/\/+$/, '') === '/week-frequency-change-summary/core') {
      document.title = '羊驼PTE Core专属高频题库'
    } else if (toMeta.title) {
      document.title = toMeta.title
    } else {
      document.title = '羊驼PTE官网 - PTE学习_PTE考试培训_PTE真题_PTE机经'
    }
    return true
  } else if (from.name !== '首页') {
    nextTick(() => {
      setTimeout(() => {
        login()
      }, 500)
    })
    if (from.meta.noAuth) {
      return false
    } else {
      return { name: '首页', query: { CallBackUrl: encodeURIComponent(to.fullPath) } }
    }
  } else {
    login()
    return false
  }
})
router.afterEach((to, from) => {
  if (!isRadioPlayerInternalNav(to, from)) {
    NProgress.done() // 进度条消失
  }
})

// 在部署期间用户一直停留在当前项目页面（长时间无操作 半个小时+），部署完成后点击页面上的路由，报错！ 刷新后恢复正常。
router.onError((error) => {
  const fetchResourcesErrors = [
    'Failed to fetch dynamically imported module',
    'Importing a module script failed'
  ]
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed =
    error.message.match(pattern) ||
    error.message.includes('Failed to fetch dynamically imported module')
  if (
    fetchResourcesErrors.some((item) => error?.message && error.message?.includes(item)) ||
    isChunkLoadFailed
  ) {
    window.location.reload()
  }
})

export { router, menus }
